import { render, staticRenderFns } from "./SundryCreditorVendor.vue?vue&type=template&id=465c194d"
import script from "./SundryCreditorVendor.vue?vue&type=script&lang=js"
export * from "./SundryCreditorVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('465c194d')) {
      api.createRecord('465c194d', component.options)
    } else {
      api.reload('465c194d', component.options)
    }
    module.hot.accept("./SundryCreditorVendor.vue?vue&type=template&id=465c194d", function () {
      api.rerender('465c194d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sundrycreditor/SundryCreditorVendor.vue"
export default component.exports